import { gql } from '@apollo/client';
import TENANT_MANUFACTURER from 'api/fragments/TENANT_MANUFACTURER';
const ADD_MANUFACTURER_PICTURE = gql `
  ${TENANT_MANUFACTURER}
  mutation AddManufacturerPicture($manufacturerId: ID!, $file: String!) {
    addManufacturerPicture(manufacturerId: $manufacturerId, file: $file) {
      manufacturer {
        ...TenantManufacturerFragment
      }
    }
  }
`;
export default ADD_MANUFACTURER_PICTURE;
